import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Output, Input, EventEmitter } from '@angular/core';
import { AnalyticsService } from '../../services/api';
import { NgxChartsModule, ScaleType } from '@swimlane/ngx-charts';
import { DatePipe } from '@angular/common';
import { scaleBand } from 'd3-scale';

@Component({
	selector: 'title-report',
	templateUrl: 'title-report.component.html',
	styleUrls: ['title-report.component.scss'],
	providers: [DatePipe]
})

export class TitleReportComponent implements OnInit, OnChanges {
	@Input() deviceId:number = -1;
	@Input() schoolId:number = -1;
	@Input() projectId:number | undefined = -1;
	@Input() isout:boolean | undefined = false;
	@Input() viewsize: [number, number] = [800, 600];
	@Input() outstartDate: Date = new Date();
	@Input() outendDate: Date = new Date();
	@Output() backEvent = new EventEmitter();
	reportdata :any[] = [];
	colorScheme = 		{
		name: 'vivid',
		selectable: true,
		group: ScaleType.Ordinal,
		domain: [
			'#e85c25','#f0a617','#95c429','#348146','#15a9a8','#00aeef','#005794','#a14572'
		]
	  }
	// options
	showXAxis: boolean = false;
	showYAxis: boolean = true;
	gradient: boolean = false;
	showLegend: boolean = true;
	showXAxisLabel: boolean = true;
	xScaleMin:number = 20;
	yAxisLabel: string = 'Books';
	showYAxisLabel: boolean = true;
	xAxisLabel: string = 'Number of Events';
	maxYAxisTickLength: number = 30;
	trimYAxisTicks: boolean = true;
	customColors: any[] = [];
	currentDate : string = '';
	startDate: Date = new Date();
	endDate: Date = new Date();
	ngOnInit() {
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else if(this.projectId != -1){
			this.getProjectReports();
		}else{
			this.getDeviceReports();
		}
	}

	barTooltipText(c:any): string {
		return `
		  <span class="tooltip-label">${c.label} • ${c.cell.date.toLocaleDateString()}</span>
		  <span class="tooltip-val">Total Events: ${c.data.toLocaleString()}</span>
		`;
	  }

	private getDateString(day:Date){
		if(day == null) day = new Date();
		return this.datePipe.transform(day, 'yyyy-MM-dd')!;
	}

	onSelectDate(){
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else if(this.projectId != -1){
			this.getProjectReports();
		} else{
			this.getDeviceReports();
		}
	}


	private getSchoolReports(){
		this.service.analyticsGetTitleSchoolReportPost(this.schoolId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
		});
	}

	private getProjectReports(){

		this.service.analyticsGetTitleProjectReportPost(this.projectId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
		});
	}

	private getDeviceReports(){

		this.service.analyticsGetTitleDeviceReportPost(this.deviceId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
		});
	}


	private prepareData(data: any[]){
		let currentdata:any[] = [];
		data.sort((a, b)=> b.count - a.count);
		if(this.isout) data = data.slice(0, 5);
		data.forEach(item =>{
			currentdata.push(this.getData(item.name!,item.count!));
		});
		currentdata = this.addMore(currentdata);
		this.reportdata = currentdata;
	}

	navigateBack(){
		this.backEvent.next(null);
	}

	constructor(private service: AnalyticsService, private datePipe: DatePipe) {
		const today = new Date()
		let day = 86400000
		this.startDate = new Date(today.getTime() - (3 * 30 * day));
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes.outstartDate){
			this.outstartDate = new Date(changes.outstartDate.currentValue);
			console.log(this.outstartDate);
			const today = new Date()
			let day = 86400000
			this.endDate = new Date(this.outstartDate.getTime() + (90 * day));
			if(!this.isout){
				this.startDate = new Date(today.getTime() - (365 * day));
			}
			else{
				this.startDate = this.outstartDate;
				this.endDate = this.outendDate
			}


			if(this.schoolId != -1){
				this.getSchoolReports()
			}else if(this.projectId != -1){
				this.getProjectReports();
			}else{
				this.getDeviceReports();
			}

	}

	}

	  getData(name: string, count: number){
		  name = name.replace(".epub","");
		  //name = name.substring(0, 30);
		  //if(name.length>0 && name.length<30) name += "...";
		  return  {name:name,value:count};
	  }

	  addMore(data : any[]){
    if(data.length === 0) return data;
		for(let i:number=0;i<5-data.length;i++){
			data.push(this.getData('',0));
		}
		return data;
	}
}
